"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconBookmarkOutline = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M19,3 L5,3 L5,21 L12,18 L19,21 L19,3 Z M17,18 L12,15.82 L7,18 L7,5 L17,5 L17,18 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconBookmarkOutline')(IconBookmarkOutline);